import { render, staticRenderFns } from "./Relative.vue?vue&type=template&id=52c53fe5&"
import script from "./Relative.vue?vue&type=script&lang=js&"
export * from "./Relative.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports